module.exports = __webpack_public_path__ + "img/暂无数据@2x.9efb05c4.png";